/*
 *--------------------------------------------------------------------------
 * Facets
 *--------------------------------------------------------------------------
 *
 * This class is used to extend Miva facets functionality
 *
 */
export default class Facets {
	constructor () {
		this.bindEvents();
	}

	bindEvents () {
		// Bind the applied facet label event handling
		this.bindAppliedFacetEvents();

		// Bind facet display events
		this.bindFacetDisplayEvents();
	}

	bindAppliedFacetEvents () {
		// Trigger facet updates on applied label clicks
		const facetLabels = document.getElementsByClassName('t-faceting--applied-facet-label');

		if (facetLabels.length) {
			const changeEvent = document.createEvent('HTMLEvents');

			changeEvent.initEvent('change', false, true);

			for (const element of facetLabels) {
				const facetId = element.getAttribute('data-applied-facet-id');

				if (facetId) {
					let facetInput = document.querySelector('[data-facet-id="' + facetId + '"]');

					if (facetInput) {
						element.addEventListener('click', function () {
							if (facetInput.tagName === 'OPTION') {
								const facetSelect = facetInput.closest('select');

								if (facetSelect) {
									facetInput.selected = false;
									facetSelect.dispatchEvent(changeEvent);
								}
							} else {
								facetInput.click();
							}
						}, false);
					}
				}
			}
		}
	}

	bindFacetDisplayEvents () {
		// Bind the facet collapsible events
		this.bindCollapseEvents();

		// Bind the Show More/Show Less events
		this.bindShowMoreEvents();
	}

	bindCollapseEvents () {
		const facetSetLabels = document.getElementsByClassName('x-facet-set__label');

		if (facetSetLabels.length) {
			for (const element of facetSetLabels) {
				const facetSet = element.closest('.x-facet-set');

				if (facetSet) {
					const facetSetList = facetSet.querySelector('.x-facet-set__list');

					if (facetSetList) {
						element.addEventListener('click', () => {
							if (facetSet.classList.contains('is-collapsed')) {
								facetSet.classList.remove('is-collapsed');
								element.setAttribute('aria-expanded', 'true');
							} else {
								facetSet.classList.add('is-collapsed');
								element.setAttribute('aria-expanded', 'false');
							}
						}, false);
					}
				}
			}
		}
	}

	// eslint-disable-next-line
	bindShowMoreEvents () {
		const showMoreElements = document.getElementsByClassName('t-facet-set__list-show-more');

		if (showMoreElements.length) {
			for (const element of showMoreElements) {
				// Set the Show More element cut off count. Based on the 'data-show-count' attribute, defaults to 6.
				const showCount = parseInt(element.getAttribute('data-show-count') || 6, 10);
				const showMoreLink = element.querySelector('.t-facet-set__list-show-more-link');
				const showMoreText = showMoreLink.getAttribute('data-show-more-text') || 'Show More';
				const showLessText = showMoreLink.getAttribute('data-show-less-text') || 'Show Less';

				// Set the max height on the parent containers
				const facetSetList = element.closest('.x-facet-set__list');

				if (facetSetList && showMoreLink) {
					const facetSetListItems = facetSetList.querySelectorAll('.x-facet-set__list-item:not(.t-facet-set__list-show-more)');

					if (facetSetListItems.length) {
						facetSetListItems.forEach((listItem, index) => {
							if (index >= showCount) {
								listItem.classList.add('u-hidden');
							}
						});

						showMoreLink.addEventListener('click', (event) => {
							event.preventDefault();

							showMoreLink.classList.toggle('is-show-less');

							const isShowLess = showMoreLink.classList.contains('is-show-less');

							facetSetListItems.forEach((listItem, index) => {
								if (index >= showCount && !isShowLess) {
									listItem.classList.add('u-hidden');
								} else {
									listItem.classList.remove('u-hidden');
								}
							});

							if (isShowLess) {
								showMoreLink.textContent = showLessText;
							} else {
								showMoreLink.textContent = showMoreText;
							}
						}, false);

						element.classList.remove('u-hidden');
					}
				}
			}
		}
	}
}
